import { Component, OnInit } from '@angular/core';
import { UrlHistoryService } from '../../services/url.history.service';
import { AppStateService } from '../../services/app-state.service';
import { AppState } from '../../models/AppState';
import { Subscription } from 'rxjs';
import { CircleButtonComponent } from '../buttons/circle-button.component';
import { LoadingSpinnerComponent } from "../ui/loading-spinner-component";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigPayment } from '../../models/FSConfig';
import { LangUtils } from '../../utils/Utils';
import { TermsNoComponent } from './terms-no.component';

@Component({
  selector: 'app-terms',
  standalone: true,
  imports: [
    CircleButtonComponent,
    CommonModule,
    LoadingSpinnerComponent,
    TermsNoComponent
  ],
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent implements OnInit {
  // The venue's language decides which terms are shown (they are the seller's legal text, not UI copy):
  // "no" gives the Norwegian kjøpsvilkår, anything else the Swedish page below.
  lang = "sv";
  busName: string | null = null;
  orgNumber: string | null = null;
  busAddress: string | null = null;
  email: string | null = null;
  phone: string | null = null;
  payment: ConfigPayment | null = null;
  swishInfo: string | null = null;
  app: AppState | null = null;
  public isLoading: boolean | null = null;
  private sub: Subscription | undefined;

  constructor(private appState: AppStateService, private identityService: UrlHistoryService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.sub = this.appState.observeAppState().subscribe(appState => {
      this.isLoading = false;
      this.app = appState;
      this.lang = LangUtils.venueLanguage(appState.cfg);
      this.busName = appState.cfg.bus_name ?? null;
      this.orgNumber = appState.cfg.org_number ?? null;
      this.busAddress = appState.cfg.bus_address ?? null;
      this.email = appState.cfg.email ?? null;
      this.phone = appState.cfg.phone ?? null;
      this.payment = appState.cfg.payment ?? null;
      this.swishInfo = appState.cfg.swish_info ?? null;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  back() {
    this.identityService.navigateBack();
  }
}
